import React from "react";
import { useTranslation } from "react-i18next";

import howDoesItWorkCardImgOne from "../../assets/img/how-does-it-work-card-img-one.png";
import howDoesItWorkCardImgTwo from "../../assets/img/how-does-it-work-card-img-two.png";
import howDoesItWorkCardImgThree from "../../assets/img/how-does-it-work-card-img-three.png";
import freshdeskHowItWorksIllustration from "../../assets/img/freshdesk-how-does-it-work-Illustration.png";
import contentMasterHowItWorksIllustration from "../../assets/img/content-master-how-does-it-work-Illustration.png";
import gpsrHowItWorksIllustration from "../../assets/img/gpsr-how-does-it-work-Illustration.png";
import gpsrHowItWorksMobile from "../../assets/img/Illustration-Invoices.png";

import shipmentTrackerHowItWorksIllustration from "../../assets/img/shipment-tracker-how-does-it-work-Illustration.png";
import mobileOrderExample from "../../assets/img/mobile-order.png";
import mobileChart from "../../assets/img/mobile-chart.png";

import freshdeskIcon1 from "../../assets/icons/freshdesk-1.svg";
import freshdeskIcon2 from "../../assets/icons/freshdesk-2.svg";
import freshdeskIcon3 from "../../assets/icons/freshdesk-3.svg";
import contentMasterIcon1 from "../../assets/icons/matrix-1.svg";
import contentMasterIcon2 from "../../assets/icons/matrix-2.svg";
import contentMasterIcon3 from "../../assets/icons/matrix-3.svg";
import gpsrIcon1 from "../../assets/icons/gpsr-1.svg";
import gpsrIcon2 from "../../assets/icons/gpsr-2.svg";
import gpsrIcon3 from "../../assets/icons/gpsr-3.svg";
import mobileIcon1 from "../../assets/icons/mobile-1.svg";
import mobileIcon2 from "../../assets/icons/mobile-2.svg";
import mobileIcon3 from "../../assets/icons/mobile-3.svg";
import mobileIcon4 from "../../assets/icons/mobile-4.svg";
import googleReviewManagerIcon1 from "../../assets/icons/google-review-manager-how-it-work-1.svg";
import googleReviewManagerIcon2 from "../../assets/icons/google-review-manager-how-it-work-2.svg";
import googleReviewManagerIcon3 from "../../assets/icons/google-review-manager-how-it-work-3.svg";

interface HowItWorksProps {
  licenseType: string;
  className?: string;
}

const HowItWorks: React.FC<HowItWorksProps> = ({
  licenseType,
  className = "",
}) => {
  const { t } = useTranslation();

  const getRobotIcon = () => {
    switch (licenseType) {
      case "freshdesk":
        return freshdeskHowItWorksIllustration;
      case "content_master":
        return contentMasterHowItWorksIllustration;
      case "gpsr":
        return gpsrHowItWorksIllustration;
      case "mobile":
        return gpsrHowItWorksMobile;
      case "google_review_manager":
        return gpsrHowItWorksIllustration;
      case "shipment_tracker":
        return shipmentTrackerHowItWorksIllustration;
      default:
        return freshdeskHowItWorksIllustration;
    }
  };

  const getIcon = (index: number) => {
    switch (licenseType) {
      case "freshdesk":
        switch (index) {
          case 1:
            return freshdeskIcon1;
          case 2:
            return freshdeskIcon2;
          case 3:
            return freshdeskIcon3;
          default:
            return "";
        }
      case "content_master":
        switch (index) {
          case 1:
            return contentMasterIcon1;
          case 2:
            return contentMasterIcon2;
          case 3:
            return contentMasterIcon3;
          default:
            return "";
        }
      case "gpsr":
        switch (index) {
          case 1:
            return gpsrIcon1;
          case 2:
            return gpsrIcon2;
          case 3:
            return gpsrIcon3;
          default:
            return "";
        }
      case "mobile":
        switch (index) {
          case 1:
            return mobileIcon1;
          case 2:
            return mobileIcon2;
          case 3:
            return mobileIcon3;
          case 4:
            return mobileIcon4;
          default:
            return "";
        }
      case "google_review_manager":
        switch (index) {
          case 1:
            return googleReviewManagerIcon1;
          case 2:
            return googleReviewManagerIcon2;
          case 3:
            return googleReviewManagerIcon3;
          default:
            return "";
        }
      case "shipment_tracker":
        switch (index) {
          case 1:
            return googleReviewManagerIcon1;
          case 2:
            return googleReviewManagerIcon2;
          case 3:
            return googleReviewManagerIcon3;
          default:
            return "";
        }
      default:
        return "";
    }
  };

  return (
    <div className={`how-it-works ${className}`}>
      <h2 className="block-title">{t("see_how_it_works_section.title")}</h2>
      <div className="how-it-works-container">
        <div className="how-it-works-steps">
          {licenseType !== "mobile" && (
            <>
              <div className="how-it-works-robot">
                <img src={getRobotIcon()} alt="robot" />
              </div>
              <div className="how-it-works-step">
                <div className="step-content">
                  <div className="step-content-inner">
                    <h3 className="step-title">
                      {t(`${licenseType}.how_does_it_work.card1.title`)}
                    </h3>
                    <span className="step-icon">
                      <img src={getIcon(1)} alt="icon" />
                    </span>
                  </div>
                  <p className="step-description">
                    {t(`${licenseType}.how_does_it_work.card1.description`)}
                  </p>
                </div>
              </div>
              <div className="how-it-works-step">
                <div className="step-content">
                  <div className="step-content-inner">
                    <h3 className="step-title">
                      {t(`${licenseType}.how_does_it_work.card2.title`)}
                    </h3>
                    <span className="step-icon">
                      <img src={getIcon(2)} alt="icon" />
                    </span>
                  </div>
                  <p className="step-description">
                    {t(`${licenseType}.how_does_it_work.card2.description`)}
                  </p>
                </div>
              </div>
              <div className="how-it-works-step">
                <div className="step-content">
                  <div className="step-content-inner">
                    <h3 className="step-title">
                      {t(`${licenseType}.how_does_it_work.card3.title`)}
                    </h3>
                    <span className="step-icon">
                      <img src={getIcon(3)} alt="icon" />
                    </span>
                  </div>
                  <p className="step-description">
                    {t(`${licenseType}.how_does_it_work.card3.description`)}
                  </p>
                </div>
              </div>
            </>
          )}
          {licenseType === "mobile" && (
            <div className="how-it-works-steps-mobile">
              <div className="how-it-works-robot how-it-works-robot-mobile">
                <img src={getRobotIcon()} alt="robot" />
              </div>
              <div className="how-it-works-content-mobile">
                <div className="how-it-works-left-content">
                  <div className="how-it-works-left-content-inner">
                    <div className="how-it-works-step">
                      <div className="step-content">
                        <div className="step-content-inner">
                          <h3 className="step-title">
                            {t(`${licenseType}.how_does_it_work.card1.title`)}
                          </h3>
                          <span className="step-icon">
                            <img src={getIcon(1)} alt="icon" />
                          </span>
                        </div>
                        <p className="step-description">
                          {t(
                            `${licenseType}.how_does_it_work.card1.description`,
                          )}
                        </p>
                        <a
                          href="https://www.jtl-software.de/extension-store/seller2go-smartphone-app-dashboard-dein-jtl-shop-immer-im-blick-jtl-shop-5"
                          target="_blank"
                          className="install-plugin-button btn btn-primary"
                        >
                          {t("install_plugin_button")} ↗
                        </a>
                      </div>
                    </div>
                    <div className="how-it-works-step">
                      <div className="step-content">
                        <div className="step-content-inner">
                          <h3 className="step-title">
                            {t(`${licenseType}.how_does_it_work.card2.title`)}
                          </h3>
                          <span className="step-icon">
                            <img src={getIcon(2)} alt="icon" />
                          </span>
                        </div>
                        <p className="step-description">
                          {t(
                            `${licenseType}.how_does_it_work.card2.description`,
                          )}
                        </p>
                        <div className="step-content-image">
                          <img src={mobileChart} alt="chart" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="how-it-works-left-content-bottom">
                    <div className="how-it-works-step long">
                      <div className="step-content step-content-with-image">
                        <div className="step-content-image">
                          <img
                            src={mobileOrderExample}
                            alt="order-details-example"
                          />
                        </div>
                        <div className="step-content-with-image-inner">
                          <div className="step-content-inner">
                            <h3 className="step-title">
                              {t(`${licenseType}.how_does_it_work.card3.title`)}
                            </h3>
                            <span className="step-icon">
                              <img src={getIcon(3)} alt="icon" />
                            </span>
                          </div>
                          <p className="step-description">
                            {t(
                              `${licenseType}.how_does_it_work.card3.description`,
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="how-it-works-right-content">
                  <div className="how-it-works-store-status">
                    <div className="how-it-works-status-top-toggler">
                      <div className="how-it-works-status-top-toggler-inner">
                        <span>Turn off the store</span>
                        <span className="apple-toggle">
                          <span className="apple-toggle-inner">
                            <span className="apple-toggle-inner-item"></span>
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="step-content step-transparent">
                      <div className="step-content-inner">
                        <h3 className="step-title">
                          {t(`${licenseType}.how_does_it_work.card4.title`)}
                        </h3>
                        <span className="step-icon">
                          <img src={getIcon(4)} alt="icon" />
                        </span>
                      </div>
                      <p className="step-description">
                        {t(`${licenseType}.how_does_it_work.card4.description`)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
